var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "marketing-attributes-revision-diff-modal__tab-item" },
    [
      _c(
        "CompassTable",
        { attrs: { size: "medium" } },
        [
          _c(
            "CompassTableBody",
            _vm._l(_vm.attributes, function(attribute) {
              return _c(
                "CompassTableRow",
                {
                  key:
                    "marketing-attributes-revision-diff-modal__tab-item-" +
                    attribute.id
                },
                [
                  _c(
                    "CompassTableBodyCell",
                    {
                      staticClass:
                        "marketing-attributes-revision-diff-modal__tab-item-label"
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "typographies-paragraph-medium-semibold"
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(attribute.label) +
                              "\n                    "
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "CompassTableBodyCell",
                    {
                      staticClass:
                        "marketing-attributes-revision-diff-modal__tab-item-categories"
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "typographies-paragraph-medium-regular"
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                attribute.category
                                  ? attribute.category.label
                                  : ""
                              ) +
                              "\n                    "
                          )
                        ]
                      )
                    ]
                  )
                ],
                1
              )
            }),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }